"use client";

const ED = {
  font: 'var(--font-geist-sans), system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  text: "#0c4a6e",
  secondary: "#64748b",
  muted: "#94a3b8",
  r12: "12px",
};

const sections = [
  {
    title: "Signed in, ready to work",
    body: "Your email link proved it was you — your session loads with your account already attached. No second signup screen.",
  },
  {
    title: "Finance desk vs Stock & counts",
    body: "Under the Dashboard tab, toggle **Finance desk** (Rand totals and line values) or **Stock & counts** (emphasise bottles, boxes, and quantities with less money on cards). Your choice is saved for this account on this browser.",
  },
  {
    title: "Add a sheet",
    body: "Tap **+ Add sheet**. Use a clear photo or file of your stock sheet; we turn lines into rows on your dashboard. Different departments, different days — one list.",
  },
  {
    title: "Batch scan",
    body: "Walk the **Batch scan** flow with a phone or tablet: work the dispensary shelf by shelf, scan each product, then **Submit** when the run is complete. Rows land in the same expiry list.",
  },
  {
    title: "One line at a time",
    body: "**+ Add line** opens a quick form for a single product. Tap a card to adjust quantity, expiry, or status so your values stay accurate.",
  },
  {
    title: "Filter and sort",
    body: "**All / Active / Moved / Expired** narrows the view. **Sort** prioritises by urgency, quantity, name, and (in Finance desk) line value.",
  },
  {
    title: "The three tiles",
    body: "The three tiles track write-offs, risk, and recovered stock. In **Finance desk** they show money; in **Stock & counts** they show line counts and quantity totals — useful on the ward and at month-end.",
  },
  {
    title: "Plan and billing",
    body: "**Billing** opens your subscription. **Pricing** explains Pro vs Premium and how scan limits work.",
  },
  {
    title: "Reminders vs marketing",
    body: "Optional **Email digests** are operational reminders. Marketing email is a separate choice at sign-up.",
  },
];

function RichLine({ text }) {
  const parts = text.split(/\*\*(.*?)\*\*/g);
  return (
    <p style={{ margin: 0, fontSize: "0.9375rem", lineHeight: 1.65, color: ED.secondary }}>
      {parts.map((p, i) =>
        i % 2 === 1 ? (
          <strong key={i} style={{ color: ED.text, fontWeight: 700 }}>
            {p}
          </strong>
        ) : (
          <span key={i}>{p}</span>
        ),
      )}
    </p>
  );
}

export function DashboardHowToUse({ isMobile, onShowTourAgain }) {
  return (
    <div style={{ maxWidth: "720px", margin: "0 auto", fontFamily: ED.font }}>
      <div className="ed-card-glass" style={{ padding: isMobile ? "1rem 1.15rem" : "1.15rem 1.35rem", borderRadius: 16, marginBottom: "0.9rem" }}>
        <h1 style={{ margin: "0 0 0.3rem", fontSize: "clamp(1.35rem, 3.5vw, 1.65rem)", fontWeight: 700, color: ED.text, letterSpacing: "-0.035em", lineHeight: 1.2 }}>In plain language</h1>
        <p style={{ margin: 0, fontSize: "0.8125rem", color: ED.muted, lineHeight: 1.5 }}>Short sections — come back anytime.</p>
        {onShowTourAgain && (
          <button
            type="button"
            className="ed-btn-secondary"
            onClick={onShowTourAgain}
            style={{ marginTop: "1rem", padding: "0.55rem 1rem", fontFamily: ED.font, fontSize: "0.8125rem", fontWeight: 600 }}
          >
            Run the tour again
          </button>
        )}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
        {sections.map((s) => (
          <article key={s.title} className="ed-card-glass" style={{ padding: isMobile ? "0.9rem 1rem" : "1rem 1.15rem", borderRadius: ED.r12 }}>
            <h2 style={{ margin: "0 0 0.45rem", fontSize: "1.1rem", fontWeight: 700, color: ED.text, letterSpacing: "-0.025em", lineHeight: 1.3 }}>{s.title}</h2>
            <RichLine text={s.body} />
          </article>
        ))}
      </div>
    </div>
  );
}
